<template>
	<div style="flex: 1;padding: 20px;display: flex;flex-direction: column;color:#fff;font-size: 14px;">
		<div style="flex:1;background-color: rgb(75, 83, 87);display: flex;flex-direction: column;">
			<div style="padding: 15px;border-bottom: 1px solid #3f4649;display: flex;align-items: center;justify-content: space-between;">
				软件列表
				<div style="display: flex;align-items: center;">
					<span style="margin-right: 10px;">共{{this.list.length}}条数据</span>
					<el-button icon="el-icon-refresh" type="primary" size="small" style="border-radius: 0;" @click="getData">刷新数据</el-button>
				</div>
			</div>
			<el-table :data="list" stripe
				style="width: 100%;flex: 1;padding:0px 0px;background-color: rgb(75, 83, 87);color: #fff;" size="small"
				@selection-change="handleSelectionChange"
				:header-cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}"
				:cell-style="{background:'rgb(75, 83, 87)',color:'#fff'}" :row-style="{border_color:'rgb(75, 83, 87)'}"
				height="500" v-loading="loading">
				<el-table-column prop="id" label="软件ID" align="center" width="150">
				</el-table-column>
				<el-table-column label="软件名称" align="center" min-width="140">
					<template slot-scope="scope">
						{{scope.row.name}}
					</template>
				</el-table-column>
				<el-table-column label="软件备注" align="center" min-width="150">
					<template slot-scope="scope">
						{{scope.row.one||'-'}}
					</template>
				</el-table-column>
				<el-table-column label="在线数量" align="center" min-width="80">
					<template slot-scope="scope">
						<el-link type="success" :underline="false">{{scope.row.online_member}}</el-link> 
					</template>
				</el-table-column>
				<el-table-column label="帐号注册充值地址" width="150" align="center">
					<template slot-scope="scope">
						 <el-link type="primary" icon="el-icon-edit" @click="copy(scope.row.id,'reg_charge')">复制 </el-link>
					</template>
				</el-table-column>
				<el-table-column label="用户中心" width="150" align="center">
					<template slot-scope="scope">
						 <el-link type="primary" icon="el-icon-edit" @click="copy(scope.row.id,'ucenter')">复制 </el-link>
					</template>
				</el-table-column>
				<el-table-column label="卡密出售地址" width="150" align="center">
					<template slot-scope="scope">
						 <el-link type="primary" icon="el-icon-edit" @click="copy(scope.row.id,'buy_card')">复制 </el-link>
					</template>
				</el-table-column>
				<el-table-column label="下载地址" width="150" align="center">
					<template slot-scope="scope">
						 <el-link type="primary" icon="el-icon-edit" @click="copy(scope.row.id,'download')">复制 </el-link>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="180" align="center">
					<template slot-scope="scope">
						<el-button type="warning" size="mini" @click="toEdit(scope.row)">修改</el-button>
						<el-button type="danger" size="mini" @click="toDelete(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex;align-items: center;justify-content: center;padding: 10px;font-size: 13px;color: #fff;">
				软件展示列表：<el-link @click="open" type="primary">http://u.2cccc.cc/software_list.html?center_id={{user.center_id}}</el-link>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		data() {
			return {
				loading: false,
				limit: 15,
				total: 0,
				form: {
					card: "",
					card_state: "all",
					card_type: "",
					page: 1,
					software: ''
				},
				list: [],
				multipleSelection: []
			}
		},
		created() {
			this.getData()
		},
		computed: {
			...mapState({
				reload:state=>state.reload,
				user:state=>state.user
			})
		},
		watch:{
			reload(n,v){
				this.getData()
			}
		},
		methods: {
			open(){
				window.open('http://u.2cccc.cc/software_list.html?center_id='+this.user.center_id)
			},
			copy(software_id,type){
				this.$H.post('verify_center/v1_0_2.Software/Info',{
					id:software_id
				}).then(res => {
					if(res.data){
						let url = ''
						if(type==='reg_charge'){
							url = res.data.ucenter_domain+'reg_charge.html?sell_code='+res.data.sell_code
						}else if(type==='ucenter'){
							url = res.data.ucenter_domain+'ucenter.html?sell_code='+res.data.sell_code
						}else if(type==='buy_card'){
							url = res.data.ucenter_domain+'buy_card.html?sell_code='+res.data.sell_code
						}else{
							url = res.data.path
						}
						console.log(url)
						this.$copyText(url).then((e) => {
							this.$message.success('复制成功')
							console.log(e)
						}, (e) => {
							console.log(e)
						})
					}
					
				});
			},
			search() {
				this.form.page = 1
				this.getData()
			},
			getData() {
				this.loading = true
				this.$H.post('/verify_center/v1_0_2.Software/List', {}).then(res => {
					this.loading = false
					if (res.data) {
						this.list = res.data.list
					}
				}).catch(err => {
					this.loading = false
				})
			},
			toDelete(item) {
				this.$confirm('是否删除该软件?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$H.post('/verify_center/v1_0_1.Software/Delete', {
						id:item.id
					}).then(res => {
						if(res.data){
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
							this.getData()
						}
					});
			
				}).catch(() => {
			
				});
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			toPage(val) {
				this.form.page = val
				this.getData()
			},
			toEdit(item){
				console.log(item)
				this.$emit('toEdit',item.id)
			}
		}
	}
</script>

<style>
	.search input {
		background-color: rgb(75, 83, 87);
		color: #fff;
		border-radius: 0px;

	}

	.el-dialog__header {
		background-color: #409EFF;
		color: #fff;
	}

	.el-dialog__header .el-dialog__title {
		color: #fff;
	}

	.el-dialog__close el-icon el-icon-close {
		color: #fff;
	}

	.footer {
		margin-top: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 10px 0;
	}

	.footer .el-pagination__total {
		color: #fff !important;
	}

	.footer input {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
		border-radius: 0;
	}

	.footer>>>.btn-prev {
		background-color: rgb(75, 83, 87) !important;
		color: #fff;
	}

	.el-table td.el-table__cell,
	.el-table th.el-table__cell.is-leaf {
		border-bottom: 1px solid #909399 !important;
	}
</style>